/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/customTaskHandlers/contractBasedInvoiceHandlers/returnToManualConnect"/>
import { addHandler } from "Core/Medius.Core.Web/Scripts/Medius/core/customTaskHandlers/customTaskHandlersProvider";
import * as rest from "Core/Medius.Core.Web/Scripts/Medius/core/communication/json/rest";
import { isContractBasedInvoiceRemediumFlowEnabled } from "Core/Medius.Core.Web/Scripts/Medius/core/featureToggle";

export function register() {
    addHandler({
        canHandle: function (vm: any, _task: any) {
            if(isContractBasedInvoiceRemediumFlowEnabled())
            {
                const isRemediumWorkflow = _task.WorkflowContext && _task.WorkflowContext() === null;
                const isReturnToManualConnect = vm.TaskName && vm.TaskName() === "ReturnToManualConnect";
                const isContractBasedInvoice = _task.Document().$type() === "Medius.ContractbasedInvoice.Entities.ContractbasedInvoice, Medius.ContractbasedInvoice.Common";
                return isRemediumWorkflow && isContractBasedInvoice && isReturnToManualConnect;
            }

            return false;
        },
        handle: function (task: any, _: any) {
            return function () {
                return rest.post("remedium-api", "contractBasedInvoice/workflow/returnToManualConnect", {
                    DocumentId: task.Document().Id(),
                    UserTaskId: task.Id(),
                    ConnectedInvoicingPlanItemId: task.Document().ConnectedInvoicingPlanItem().Id()
                });
            };
        }
    });
}
